type Props = {
	/** 0 - `max`, rendered with one decimal in nl-NL notation ("9,0"). */
	value: number;
	max?: number;
	size?: "sm" | "md";
};

export function Score({ value, max = 10, size = "md" }: Props) {
	const formatted = value.toLocaleString("nl-NL", {
		minimumFractionDigits: 1,
		maximumFractionDigits: 1,
	});

	return (
		<span
			style={{
				display: "inline-flex",
				alignItems: "baseline",
				gap: 3,
				color: "var(--score-fg)",
			}}
		>
			<span
				style={{
					fontFamily: "var(--font-display)",
					fontWeight: 800,
					letterSpacing: "-0.025em",
					fontSize: size === "sm" ? 26 : 32,
				}}
			>
				{formatted}
			</span>
			<span
				style={{
					fontSize: size === "sm" ? 13 : 14,
					fontWeight: 700,
					color: "var(--content-muted)",
				}}
			>
				/{max}
			</span>
		</span>
	);
}
